export class GlobalConst {
  static url = window.location.origin;
  static betaUrl = 'https://beta.ikointl.com/';
  static iwoUrl = 'https://www.iwointl.com/';
  static buyStripeUrl = 'https://buy.stripe.com/3csbLO59OapK43m14J';
  static shareToFriendsAppUrl = 'https://onelink.to/gcbnxq';
  static indexDb = {
    version: 3,
    name: 'iko-DB' as string,
    videos: 'eLearningVideos' as string,
    ebooks: 'eLearningEbooks' as string,
  };
}
